import styled from 'styled-components';

export const TitlebarContainer = styled.div``;
